import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productInformationStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";

productInformationStyles.container = mergeToNew(productInformationStyles.container, {
    css: css`
        padding-left: 20px;
        padding-right: 20px;
    `,
});

productInformationStyles.availabilityStyles = mergeToNew(productInformationStyles.availabilityStyles, {
    availabilityByWarehouseLink: {
        typographyProps: {
            size: 14,
        },
    },
});
